import { priceTooltipToggleTpl } from '../priceToggle/priceToggleTpl';
import { sliderPhotosTpl } from '../sliderPhotos/sliderPhotosTpl';
import { formatPriceDecimal } from '../../utils/js/formatPriceDecimal';

/**
 * Activity popin template
 * @param {object} datas
 * @param {object} datas.data
 * @param {object[]} datas.data.prestation
 * @param {object} datas.wordings
 * @param {string} datas.urlBase
 * @return {string} - Formatted HTML
 */
const popinActivityTpl = function (datas) {
  const activity = datas.data.prestation[0],
    wordings = datas.wordings,
    isCurrencyBefore = ['nl', 'be', 'in'].indexOf(GLOBAL_SCRIPTS.MARKET_CODE) !== -1,
    currencyHtml = `<span class="currency${!isCurrencyBefore ? ' currencyIsAfter' : ''}">${GLOBAL_SCRIPTS.CURRENCY_SYMBOL}</span>`,
    pmsArray = activity.pms ? activity.pms : [],
    activityPrice = parseFloat(activity.bestPromoPrice),
    isIncluded = parseInt(activity.paying) === 0,
    isPrebookable = parseInt(activity.prebookable) === 1;

  let htmlDaughters = '';
  let htmlVoucher = '';
  let priceLabel = '';
  let prebookableLabel = '';
  let toolTipText = '';

  if (isIncluded) {
    priceLabel = `${wordings.price_included}`;
    toolTipText = wordings.price_tooltip_included;
  } else {
    if (activityPrice > 0) {
      const priceFormatted = formatPriceDecimal(activity.bestPromoPrice);
      priceLabel = `${wordings.from_price} <span class="price">${isCurrencyBefore ? `${currencyHtml} ${priceFormatted}` : `${priceFormatted} ${currencyHtml}`}</span>`;
      toolTipText = wordings.price_tooltip;
    } else {
      priceLabel = `${wordings.price_unavailable}`;
      toolTipText = wordings.price_tooltip_unavailable;
    }
  }

  if (isPrebookable) {
    prebookableLabel = `<p class="prebookable-notice"> ${wordings.prebookable_activity} </p>`;
  }

  //-- Create filters tag
  let htmlFilters = '<ul class="popinActivity-filters">';
  let ageList = false;

  if (isIncluded) {
    htmlFilters += `<li class='icon icon-budget'>${wordings.included}</li>`;
  }

  $.each(activity.age, (index, item) => {
    if (!ageList) {
      ageList = item.name;
    } else {
      ageList += ', ' + item.name;
    }
  });

  if (ageList) {
    htmlFilters += `<li class='icon icon-baby'>${ageList}</li>`;
  }

  if (parseInt(activity.inside) === 1) {
    htmlFilters += `<li class='icon icon-domain_map'>${wordings.inside}</li>`;
  }

  if (parseInt(activity.outside) === 1) {
    htmlFilters += `<li class='icon icon-excursions'>${wordings.outside}</li>`;
  }

  if (parseInt(activity.onsite) === 0) {
    htmlFilters += `<li class='icon icon-excursions' >${wordings.notInPark}</li>`;
  }

  if (parseInt(activity.new) === 1) {
    htmlFilters += `<li class='icon icon-home'>${wordings.new}</li>`;
  }

  htmlFilters += '</ul>';

  const htmlPrice = `
  <div class="popinActivity-price${activityPrice > 0 ? '' : ' unavailable'}">
    <p class="popinActivity-price-label">
      ${priceLabel}
      ${priceTooltipToggleTpl({
    tooltipOptions: {
      simpleText: toolTipText.replaceAll('\'', '’'),
      blockClass: 'popinActivity-tooltip'
    },
    trackingGaClickCode: 'clickActivitiesBlock',
    trackingGaAction: 'Click on price activity info',
    trackingGaLabel: 'Price ' + (isIncluded ? 'included' : activityPrice > 0 ? 'available' : 'unavailable')
  })}
    </p>
    ${prebookableLabel}
  </div>`;

  const daughtersDispo = pmsArray.filter(function(daughter) {
    return parseInt(daughter.dispo) === 1 && parseInt(daughter.promoPrice) !== 0;
  });

  if (daughtersDispo.length > 1) {
    htmlDaughters += `
    <div class="popinActivity-daughters${daughtersDispo.length > 1 ? ' has-column' : ''}">
      <a class="popinActivity-daughters-link api_toggle buttonContainer js-showPrices" toggleClass="open" toggleSelector=".popinActivity-daughters" toggleOpenText="${wordings.activity_see_price}" toggleCloseText="${wordings.activity_hide_price}" toggleCallback="popinActivity:anchorToPrices">
        <span class="button button--greenWhite"><span class="api_toggleText">${wordings.activity_see_price}</span><i class="icon icon-arrow"></i></span>
      </a>
      <div class="popinActivity-daughters-list">
        <ul class="first">`;
    const nbLimitColumn = Math.ceil(daughtersDispo.length / 2) - 1;
    $.each(daughtersDispo, (index, item) => {
      const priceFormatted = formatPriceDecimal(item.promoPrice);

      htmlDaughters += `
          <li${(index + 1) === daughtersDispo.length ? ' class="last"' : ''}>
            ${item.name}
            <span class="price">${isCurrencyBefore ? `${currencyHtml} ${priceFormatted}` : `${priceFormatted} ${currencyHtml}`}*</span>
          </li>`;
      if (index === nbLimitColumn) {
        htmlDaughters += `
        </ul>`;
        if (daughtersDispo.length > 1) {
          htmlDaughters += `
        <ul>`;
        }
      }
    });

    htmlDaughters += `
        </ul>
        <p class="popinActivity-daughters-conditions">
          ${wordings.price_conditions}
        </p>
      </div>
    </div>`;
  }

  //gestion pictures
  let htmlPicture = '';
  const urlDesktopDefault = datas.urlBase + '/assets/images/default/640x480.jpg';
  const urlTabletDefault = datas.urlBase + '/assets/images/default/500x375.jpg';
  const urlMobileDefault = datas.urlBase + '/assets/images/default/566x250.jpg';

  if (!$.isEmptyObject(activity.photo)) {
    if( (typeof activity.photo['566x250'] !== 'undefined' && activity.photo['566x250'].length > 1) || activity.virtualtour ) {
      htmlPicture = sliderPhotosTpl({
        productCode: PRODUCT_SCRIPTS.PRODUCT_CODE,
        brandCode: PRODUCT_SCRIPTS.BRANDCODE,
        resolutionToUse: {
          desktop: '640x480',
          tablet: '500x375',
          mobile: '566x250'
        },
        openPopinOnClick: {
          desktop: false,
          tablet: false,
          mobile: false
        },
        photosDatas: activity.photo ? activity.photo : {
          '640x480': [urlDesktopDefault],
          '500x375': [urlTabletDefault],
          '566x250': [urlMobileDefault]
        },
        videoDatas: activity.video ? activity.video : {},
        virtualTour: activity.virtualtour,
        toInit: true,
        arrowTracking: '{"event":"clickEvent","clickCode":"ClickActivityDetails","gaCategory":"Product Activities","gaAction":"activityDetails","gaLabel": "slider photos"}'
      });
    } else {
      if (!$.isEmptyObject(activity.video)) {
        htmlPicture += `
        <a href="#" class="popinActivity-video js-fancybox-video" data-url="${activity.video[0]}" data-type="videoLink">
          <i class="icon icon-play"></i>`;
      }
      htmlPicture += `
          <picture>
            <source srcset="${typeof activity.photo['566x250'] !== 'undefined' ? GLOBAL_SCRIPTS.BASELINK_MEDIA + activity.photo['566x250'][0] : urlMobileDefault}" media="(max-width: 767px)">
            <source srcset="${typeof activity.photo['500x375'] !== 'undefined' ? GLOBAL_SCRIPTS.BASELINK_MEDIA + activity.photo['500x375'][0] : urlTabletDefault}" media="(max-width: 1199px)">
            <img src="${typeof activity.photo['640x480'] !== 'undefined' ? GLOBAL_SCRIPTS.BASELINK_MEDIA + activity.photo['640x480'][0] : urlDesktopDefault}" alt="${activity.name}" itemprop="image">
          </picture>`;

      if (!$.isEmptyObject(activity.video)) {
        htmlPicture += `
        </a>`;
      }
    }
  } else {
    htmlPicture += `
    <picture>
      <source srcset="${urlMobileDefault}" media="(max-width: 767px)">
      <source srcset="${urlTabletDefault}" media="(max-width: 1199px)">
      <img src="${urlDesktopDefault}" alt="${activity.name}" itemprop="image">
    </picture>`;
  }

  const htmlActivityDescription = activity.description ? `<p>${activity.description}</p>` : '';
  const htmlActivityInfo = activity.info ? `<p>${activity.info}</p>` : '';
  const htmlActivityUrl = activity.url ? `<a href="${activity.url}" class="popinActivity-desc--link">${wordings.activity_intro_more_info_url}</a>` : '';

  let arrowActivite = !!datas.data.prevActivite ? `<span class="popinActivity-arrow popinActivity-arrow--left icon icon-arrow-left" data-code="${datas.data.prevActivite}"></span>` : '';

  arrowActivite += !!datas.data.nextActivite ? `<span class="popinActivity-arrow popinActivity-arrow--right icon icon-arrow-right" data-code="${datas.data.nextActivite}"></span>` : '';

  return `
    <section class="popinActivity">
      <div class="popinActivity-top">
        <div class="popinActivity-visuals">
          ${htmlPicture}
        </div>
        <div class="popinActivity-infos">
          <div class="popinActivity-title">
            ${activity.name}
          </div>
          ${htmlFilters}
          ${htmlVoucher}
          <div class="popinActivity-desc">
            ${htmlActivityDescription}
            ${htmlActivityInfo}
            ${htmlActivityUrl}
          </div>
          ${htmlPrice}
        </div>
      </div>
      ${htmlDaughters}
      ${arrowActivite}
    </section>`;
};

export {popinActivityTpl};